import { useParams } from "react-router-dom";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import Dashboard from "../../../common/components/layout/Dashboard";
import { MaintenanceReportsDashboardProvider } from "./components/maintenance-dashboard/Maintenance.provider";
import { MaintenanceReportsDashboard } from "./components/maintenance-dashboard";
import Toast from "../../../common/components/ui/toast";

export default function MaintenanceReportsDetailsPage() {
  const { licensePlate } = useParams()

  return (
    <ToastProvider>
      <Dashboard>
        <MaintenanceReportsDashboardProvider licensePlate={licensePlate || ''}>
          <MaintenanceReportsDashboard />
        </MaintenanceReportsDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}
